<template>
  <div class="logos-block-cms">
    <div class="container p0">
      <div v-if="validBanners[0].desktop && validBanners[0].mobile" class="logos row center-xs py20 hidden-xs">
        <router-link
          v-for="(banner, index) of validBanners[0].desktop"
          :key="index"
          :to="localizedRoute('/' + index)"
          class="image-box px30"
        >
          <img :src="getThumbnailPath(banner)" :alt="banner" height="50px" width="50px">
        </router-link>
      </div>
      <div v-else class="logos row center-xs py20">
        <router-link
          v-for="(banner, index) of validBanners[0].mobile"
          :key="index"
          :to="localizedRoute('/' + index)"
          class="image-box px30"
        >
          <img :src="getThumbnailPath(banner)" :alt="banner" height="50px" width="50px">
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import { getThumbnailPath as _thumbnailHelper } from '@vue-storefront/core/helpers'

export default {
  props: {
    validBanners: {
      type: Array,
      required: true
    }
  },
  methods: {
    categoryLink (category) {
      return formatCategoryLink(category)
    },
    getThumbnailPath (urlMobile) {
      return _thumbnailHelper(urlMobile, 100, 100, 'category')
    }
  }
}
</script>

<style lang="scss" scoped>
.logos-block-cms {
  ::-webkit-scrollbar {
    height: 0;
  }
  background-color: #FDF8F5;
  @media (max-width: 767px) {
    background-color: #1396EC;
  }
  .logos {
    flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    min-height: 95px;
    max-height: 95px;
    @media (max-width: 767px) {
      min-height: 55px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      padding-top: 10px;
      padding-bottom: 10px;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
    }
  }
  .image-box {
    @media (max-width: 767px) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  img {
    @media (max-width: 767px) {
      height: 50px;
    }
  }
}
</style>
